import { APP_VERSION, GIT_COMMIT } from '../../utils/build-info';
import styles from './Footer.module.css';

export function Footer() {
  const buildLabel = `v${APP_VERSION} (${GIT_COMMIT})`;

  return (
    <footer className={styles.footer}>
      <span>&copy; {new Date().getFullYear()} SOFTEL Communications Inc.</span>
      <span className={styles.separator} aria-hidden="true">
        ·
      </span>
      <span className={styles.buildInfo} title={`Build ${buildLabel}`}>
        {buildLabel}
      </span>
    </footer>
  );
}
